<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="200px">
        <div class="item-box">
          <div class="item1">
            <el-form-item label="封面图:" prop="coverImg">
              <base-upload
                class="upload"
                :cover="params.coverImg"
                :key="params.coverImg"
                :action="action"
                :wSize="500"
                :hSize="300"
                :width="'138.5px'"
                :height="'100px'"
                @successCallback="handleAvatarSuccess"
              ></base-upload>
            </el-form-item>
            <el-input
                v-model="params.coverImg"
                size="small"
                placeholder="请输入模块图片"
            ></el-input>
          </div>
          <div class="item2">
            <el-form-item label="模块类型:" prop="moduleType">
              <el-select
                  v-model="params.moduleType"
                  placeholder="请选择模块类型"
              >
                <el-option
                    v-for="(item, idx) in moduleTypeList"
                    :key="idx"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="父模块:" prop="pid" v-show="showSummary">
              <el-select
                v-model="params.pid"
                @change="handlePidChange"
                placeholder="请选择父模块"
              >
                <el-option
                  v-for="(item, idx) in parentList"
                  :key="idx"
                  :label="item.moduleName"
                  :value="item.moduleID"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="一级模块布局方式:"
              prop="layoutSeries"
              v-show="!showSummary"
            >
              <el-select
                v-model="params.layoutSeries"
                placeholder="请选择一级模块布局方式"
                @change="handleChangeSeries"
              >
                <el-option
                  v-for="(item, idx) in layoutSeriesList"
                  :key="idx"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模块名称:" prop="moduleName">
              <el-input
                v-model="params.moduleName"
                size="small"
                placeholder="请输入模块名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序:" prop="sortNum">
              <el-input
                v-model.number="params.sortNum"
                size="small"
                placeholder="请输入排序"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否启用:" prop="status">
              <el-select v-model="params.status" placeholder="请选择">
                <el-option label="关闭" value="0"> </el-option>
                <el-option label="显示" value="1"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专题介绍:" prop="summary" v-if="showSummary">
              <el-input
                :row="3"
                type="textarea"
                @input="handleChanegSummary"
                v-model="params.summary"
                placeholder="请输入专题介绍"
              ></el-input>
            </el-form-item>

            <el-form-item label="子模块展示布局:" prop="layout" >
              <el-select v-model.number="params.layout" placeholder="请选择">
                <el-option label="宫格" :value="0"> </el-option>
                <el-option label="头像" :value="1"> </el-option>
                <el-option label="网黄" :value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="子模块专用标题:" prop="subTitle" v-if="params.layout == '2'">
              <el-input
                v-model="params.subTitle"
                size="small"
                placeholder="请输入子模块专用标题"
              ></el-input>
            </el-form-item>

            <el-form-item label="子模块内容布局:" prop="layout">
              <el-select v-model.number="params.vlayout" placeholder="请选择">
                <el-option label="宫格" :value="0"> </el-option>
                <el-option label="大横" :value="1"> </el-option>
                <el-option label="网黄" :value="2"> </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="泡芙系布局方式:"
              prop="layoutType"
              style="width: 100%"
              v-if="params.layoutSeries == 1"
            >
              <el-select
                style="width: 100%"
                @change="handleChangeLayoutType"
                v-model="params.layoutType"
                placeholder="请选择布局方式"
              >
                <el-option
                  v-for="(item, idx) in layoutOptions"
                  :label="item.label"
                  :value="item.value"
                  :key="idx"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="跳转方式:" prop="jumpType" >
              <el-select
                v-model="params.jumpType"
                placeholder="请选择跳转方式"
                @change="handleChangeJumpType"
              >
                <el-option
                  v-for="(item, idx) in jumpTypeList"
                  :label="item.label"
                  :value="item.value"
                  :key="idx"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="跳转到其他模块ID:"
              prop="jumpModuleID"
              v-if="params.jumpType === 1"
            >
              <el-input
                style="width: 150px"
                type="input"
                @input="handleChanegJumpModuleID"
                v-model="params.jumpModuleID"
                placeholder="请输入其他模块ID"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      flag: false,
      type: "",
      id: "",
      showSummary: false,
      parentList: [],
      moduleTypeList: [
        { label: "视频", value: 0 },
        { label: "帖子", value: 1 },
        { label: "暗网", value: 2 },
        { label: "图集", value: 3 },
        { label: "短视频", value: 4 },
        { label: "黄游", value: 5 },
      ],
      jumpTypeList: [
        { label: "跳转当前模块", value: 0 },
        { label: "跳转到其他模块", value: 1 },
      ],
      layoutOptions: [
        { label: "现有-四宫格横", value: 0 },
        { label: "一大四小", value: 1 },
        { label: "1.5滑动横", value: 2 },
        { label: "2.5滑动横", value: 3 },
        { label: "六宫格-横", value: 4 },
        { label: "列表-横", value: 5 },
        { label: "大横", value: 6 },
        { label: "2.5滑动竖", value: 7 },
        { label: "图集", value: 8 },
      ],
      layoutSeriesList: [
        { label: "海角系", value: 0 },
        { label: "泡芙系", value: 1 },
      ],
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      params: {
        moduleType: "",
        moduleName: "",
        subModuleName: "",
        status: "0",
        sortNum: "",
        isDarkWeb: false,
        coverImg: "",
        pid: "",
        summary: "",
        subTitle: "", // 子模块专用标题
        layout:0,
        vlayout:0,
        layoutType: "",
        jumpType: "",
        jumpModuleID: "",
        layoutSeries: 0,
      },
      // 验证规则
      rules: {
        // moduleName: [{ required: true, message: "请输入模块名称", trigger: "blur" }],
        // status: [{ required: true, message: "请输入状态", trigger: "blur" }],
        // sortNum: [
        //   { required: true, message: "请输入排序", trigger: "blur" },
        //   { validator: validatorIndex, trigger: "blur" }
        // ]
      },
    };
  },
  mounted() {
    this.getHotModule();
  },
  methods: {
    handleChangeJumpType(val) {
      this.params.jumpType = val;
      this.$forceUpdate();
    },
    handlePidChange(val) {
      this.params.pid = val;
      this.$forceUpdate();
    },
    handleChanegSummary(val) {
      this.params.summary = val;
      this.$forceUpdate();
    },
    handleChanegJumpModuleID(val){
      this.params.jumpModuleID = val;
      this.$forceUpdate();
    },
    handleChangeLayoutType(val) {
      this.params.layoutType = val;
      this.$forceUpdate();
    },
    handleChangeSeries(val) {
      this.params.layoutSeries = val;
      this.$forceUpdate();
    },
    getHotModule() {
      const params = {
        pageSize: 20,
        pageNumber: 1,
      };
      API.getModuleList(params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            res.data.map((item) => {
              item.list.forEach((children) => {
                this.parentList.push({
                  moduleID: children.moduleID,
                  moduleName: children.moduleName,
                });
              });
            });
          } else {
            this.parentList = [];
            this.total = 0;
          }
        })
        .catch(() => {});
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.coverImg = res.data.coverImg;
    },
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addCity();
          } else {
            this.editCity();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        moduleType: 0,
        moduleName: "",
        subModuleName: "",
        sectionLimit: "",
        status: "0",
        layout: 0,
        vlayout:0,
        sortNum: "",
        isDarkWeb: false,
        coverImg: "",
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(moduleType, type, data) {
      this.dialogVisible = true;
      let dialogData = JSON.parse(JSON.stringify(data));
      this.type = type;
      if (type === "edit") {
        this.title = "编辑模块";
        this.params.moduleType = dialogData.moduleType
        this.params.moduleName = dialogData.moduleName;
        this.params.layoutSeries = dialogData.layoutSeries;
        this.params.jumpType = dialogData.jumpType;
        this.params.layoutType = dialogData.layoutType;
        this.params.jumpModuleID = dialogData.jumpModuleID;
        this.params.layout = dialogData.layout
        this.params.vlayout = dialogData.vlayout

        this.params.subModuleName = dialogData.subModuleName;
        this.params.status = String(dialogData.status) || "";
        this.params.sortNum = dialogData.sortNum;
        this.params.pid = dialogData.pid || "";
        this.id = dialogData.id;


        this.params.summary = dialogData.summary;
        this.params.coverImg = dialogData.coverImg;
      } else {
        this.params.status = "1";
        this.title = "新增模块";
        this.params.moduleName = "";
        this.params.layoutSeries = 0;
        this.params.moduleType = moduleType * 1
        this.params.status = String(data.status) || "";
        this.params.sortNum = "";
        this.params.summary = dialogData.summary;
        this.params.pid = dialogData.pid || "";
        // this.id = data.id;
        this.params.id = dialogData.id;
        this.params.coverImg = "";
        this.params.layout = 0
        this.params.vlayout = 0
      }

      this.showSummary = dialogData.showSummary;
    },
    // 新增热门模块
    addCity() {
      this.params.status = Number(this.params.status);
      API.addModule(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success",
            });
            this.$emit("handlerModule");
          } else {
            this.$message.error("新增失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 编辑热门模块
    editCity() {
      this.params = Object.assign(this.params, { id: this.id });
      this.params.status = Number(this.params.status);
      API.editModule(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerModule");
          } else {
            this.$message.error("编辑失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
